import DBHelper from '../helpers/db'
import _ from 'lodash'

export const GET_SPACES_FAIL = 'GET_SPACES_FAIL'
export const GET_SPACES_OK = 'GET_SPACES_OK'
export const GET_CURRENT_SPACE_OK = 'GET_CURRENT_SPACE_OK'

export const getSpaces = () => dispatch => {
  DBHelper.getSpaces()
  .then(spaces => {
    dispatch({
      type: GET_SPACES_OK,
      payload: spaces
    })
  })
  .catch(error => {
    dispatch({
      type: GET_SPACES_FAIL,
      payload: {error}
    })
  })
}

export const getSpaceInfo = (spaceId) => dispatch => {
  Promise.all([
    DBHelper.getUsers(spaceId),
    DBHelper.getGroups(spaceId),
    DBHelper.getPasswords(spaceId)
  ])
  .then(([users, groups, passwords]) => {
    const newUsers = users.map(user => {
      const newGroups = _.keys(user.groups).map(group_id => {
        const _group = _.find(groups, {group_id})
        return _group
      })
      return {...user, groups: newGroups, group_titles: newGroups.map(group => group.title).join(', ')}
    })
    dispatch({
      type: GET_CURRENT_SPACE_OK,
      payload: {users: newUsers, groups, passwords}
    })
  })
  .catch(error => {
    console.log('Failed to get space info: ', error)
  })
}


// WEBPACK FOOTER //
// ./src/actions/spaces.js